import CustomCharterOfferCard from './CustomCharterOfferCard';
export default CustomCharterOfferCard;
